import { isPlainObject } from "lodash";
import { getModule } from 'vuex-module-decorators';
import Decisions from '@/store/modules/Decisions';

const decisionsModule = getModule(Decisions)
const PREFIX_SUFFIX_VALUE_TYPES = ['TEXT', 'NUMERICAL', 'BOOLEAN', 'CATEGORICAL'];
const VALUE_TYPES = [
    {
        display: 'CURRENCY',
        valueType: 'NUMERICAL',
        valueSubType: 'PRICE'
    },
    {
        display: 'TEXT',
        valueType: 'TEXT'
    },
    {
        display: 'PERCENTAGE',
        valueType: 'NUMERICAL',
        valueSubType: 'PERCENTAGE'
    },
    {
        display: 'NUMERIC',
        valueType: 'NUMERICAL'
    },
    {
        display: 'TRUE/FALSE',
        valueType: 'BOOLEAN'
    },
    {
        display: 'CATEGORICAL',
        valueType: 'CATEGORICAL'
    },
    {
        display: 'FILE',
        valueType: 'FILE'
    },
    {
        display: 'IMAGE',
        valueType: 'FILE',
        valueSubType: 'IMAGE'
    },
    {
        display: 'VIDEO',
        valueType: 'FILE',
        valueSubType: 'VIDEO'
    },
    {
        display: 'AUDIO',
        valueType: 'FILE',
        valueSubType: 'AUDIO'
    },
    {
        display: 'DATE AND TIME',
        valueType: 'DATE_TIME',
        valueSubType: 'DATE_TIME'
    }
];


const FACTOR_OPTIONS = [
    {
        name: `${decisionsModule.singularFactorLabel} Group`,
        description: `Organize your ${decisionsModule.pluralFactorLabel} into Groups`,
        type: "FACTOR_GROUP",
        icon: "mdi-folder-outline"
    },
    {
        name: "Text",
        description: "Store Text values",
        type: 'FACTOR',
        valueTypeDefinition: {
            valueType: "TEXT",
        },
        icon: "mdi-format-text",
    },
    {
        name: "Number",
        description: "Store Numerical values",
        type: 'FACTOR',
        valueTypeDefinition: {
            valueType: "NUMERICAL",
        },
        icon: "mdi-pound"
    },
    {
        name: "File",
        description: "Store Files",
        type: 'FACTOR',
        valueTypeDefinition: {
            valueType: "FILE",
        },
        icon: "mdi-file-outline",
    },
    {
        name: "Money",
        description: "Numerical data formatted as currency",
        type: 'FACTOR',
        valueTypeDefinition: {
            valueType: "NUMERICAL",
            valueSubType: "PRICE",
        },
        icon: "mdi-cash-usd-outline"
    },
    {
        name: "Image",
        description: "Store Images",
        type: 'FACTOR',
        valueTypeDefinition: {
            valueType: "FILE",
            valueSubType: "IMAGE",
        },
        icon: "mdi-file-image-outline"
    },
    {
        name: "Percentage",
        description: "Numerical data formatted as a percentage",
        type: 'FACTOR',
        valueTypeDefinition: {
            valueType: "NUMERICAL",
            valueSubType: "PERCENTAGE",
        },
        icon: "mdi-percent-outline",
    },
    {
        name: "Checkbox",
        description: "Store a checkable value",
        type: 'FACTOR',
        valueTypeDefinition: {
            valueType: "BOOLEAN",
        },
        icon: "mdi-checkbox-marked-outline",
    },
    {
        name: "Date & Time",
        description: "Store Date & Time values",
        type: 'FACTOR',
        valueTypeDefinition: {
            valueType: "DATE_TIME",
            format: "YYYY-MM-DD"
        },
        icon: "mdi-calendar-clock",
    },
    {
        name: "Fixed Table",
        description: "Table with a fixed # of cols & rows",
        type: "FACTOR_GROUP",
        groupTypeDefinition: {
            type: 'TABLE_FIXED',
            columnsName: 'Columns',
            rowsName: 'Rows'
        },
        icon: "mdi-table-large"
    },

    {
        name: "Growing Table",
        description: "Table with a growing # of rows",
        type: "FACTOR_GROUP",
        groupTypeDefinition: {
            type: 'TABLE_GROWING',
            dominantType: 'COLUMN',
            columnsName: 'Columns',
            rowsName: 'Rows'
        },
        icon: "mdi-table-arrow-down"
    },
    {
        name: "Category",
        description: "Store a Value(s) from a list",
        type: 'FACTOR',
        valueTypeDefinition: {
            valueType: "CATEGORICAL",
            categoricalValues: ['']
        },
        icon: "mdi-form-select",
    },
    // {
    //     name: "Video",
    //     description: "Capture a Video",
    //     type: 'FACTOR',
    //     valueTypeDefinition: {
    //         valueType: "FILE",
    //         valueSubType: "VIDEO",
    //     },
    //     icon: "mdi-file-video-outline"
    // },
    // {
    //     name: "Audio",
    //     description: "Capture an Audio recording",
    //     type: 'FACTOR',
    //     valueTypeDefinition: {
    //         valueType: "FILE",
    //         valueSubType: "AUDIO",
    //     },
    //     icon: "mdi-file-music-outline"
    // },

    {
        name: "None",
        description: "For displaying text",
        type: "FACTOR",
        valueTypeDefinition: {
            valueType: "NONE"
        },
        icon: "mdi-border-none-variant"
    },
]


const DATE_TIME_FORMATS = [
    {
        text: "YYYY-MM-DD",
        value: "YYYY-MM-DD"
    },
    {
        text: "DD-MM-YYYY",
        value: "DD-MM-YYYY"
    },
    {
        text: "YYYY/MM/DD",
        value: "YYYY/MM/DD"
    },
    {
        text: "DD/MM/YYYY",
        value: "DD/MM/YYYY"
    },
    {
        text: "YYYY-MM-DD HH:mm",
        value: "YYYY-MM-DD HH:mm"
    },
    {
        text: "DD-MMM-YYYY HH:mm",
        value: "DD-MMM-YYYY HH:mm"
    },
    {
        text: "ddd, MMM D, hh:mm A",
        value: "ddd, MMM D, hh:mm A",
    },
    {
        text: "D/MM/YY h:mm A",
        value: "D/MM/YY h:mm A"
    }
]

const CATEGORY_FORMATS = [
    {
        display: 'Drop Down Selection ',
        value: 'DROP_DOWN'
    },
    {
        display: 'Radio Buttons',
        value: 'RADIO_BUTTONS'
    }
];

const TEXT_FORMATS = [
    {
        display: 'Plain Single-line',
        value: 'PLAIN'
    },
    {
        display: 'Plain Multi-line',
        value: 'MULTI_PLAIN'
    },
    {
        display: 'Rich Text',
        value: 'RICH'
    },
    {
        display: 'HTML Text',
        value: 'HTML'
    }
]

// const scoring functions for all components
const SUMMARY_SCORING_FUNCTIONS = [
    {
        text: "Weighted Sum",
        help:
            `For ${decisionsModule.pluralFactorLabel} within this group, the score will be calculated using the average of child ${decisionsModule.singularFactorLabel} scores`,
        value: "WEIGHTED_SUM"
    },
    {
        text: "Min",
        help:
            `The score for this section will be the ${decisionsModule.singularFactorLabel} within the section with the lowest score`,
        value: "MIN"
    },
    {
        text: "Max",
        help:
            `The score for this section will be the ${decisionsModule.singularFactorLabel} within the section with the lowest score`,
        value: "MAX"
    }
];

const AUDIO_TYPES = [
    'audio/wav',
    'audio/mpeg',
    'audio/mp4',
    'audio/aac',
    'audio/aacp',
    'audio/ogg',
    'audio/webm',
    'audio/x-caf',
    'audio/flac'
]

const IMAGE_TYPES = [
    'image/png',
    'image/gif',
    'image/jpeg'
]

const DEFAULT_IMAGE_URL = {
    CARD_DEFAULT : '@/assets/marketplace-preview-card-default.png',
    PREVIEW_DEFAULT: '@/assets/marketplace-preview.png'
}

export default class ValueTypes {

    static readonly FACTOR_OPTIONS = FACTOR_OPTIONS;
    static readonly VALUE_TYPES = VALUE_TYPES;
    static readonly VALUE_TYPES_WITH_PREFIX_SUFFIX = PREFIX_SUFFIX_VALUE_TYPES;
    static readonly DATE_TIME_FORMATS = DATE_TIME_FORMATS;
    static readonly CATEGORY_FORMATS = CATEGORY_FORMATS;
    static readonly SUMMARY_SCORING_FUNCTIONS = SUMMARY_SCORING_FUNCTIONS;
    static readonly TEXT_FORMATS = TEXT_FORMATS;
    static readonly AUDIO_TYPES = AUDIO_TYPES;
    static readonly IMAGE_TYPES = IMAGE_TYPES;
    static readonly DEFAULT_IMAGE_URL = DEFAULT_IMAGE_URL;
}